// extracted by mini-css-extract-plugin
module.exports =  {"alert":"XcDr9rzsyJNzefv2P45q"};